module.exports = __webpack_public_path__ + "img/testconfigIllustration.77d1b6c6.svg";